import React from 'react';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import Detail from './components/Detail';
import {BrowserRouter,Routes,Route} from "react-router-dom";

import Login from './components/Login';
import MovieList from './components/MovieList';
import Series from './components/Series';
import WishList from './components/WishList';
import Original from './components/Original';
import TopRted from './components/TopRated';

function App() {
  return (
    <div className="App">


<BrowserRouter>
<Header/>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="details" element={<Detail />} />
      <Route path="login" element={<Login />} />
      <Route path="movies" element={<MovieList />} />
      <Route path="series" element={<Series />} />
      <Route path="wishlist" element={<WishList />} />
      <Route path="original" element={<Original />} />
      <Route path="toprated" element={<TopRted />} />
    </Routes>
  </BrowserRouter>

    </div>
  );
}

export default App;
